import { render, staticRenderFns } from "./PengaturanNotifikasiView.vue?vue&type=template&id=378ab79c&scoped=true"
import script from "./PengaturanNotifikasiView.vue?vue&type=script&lang=js"
export * from "./PengaturanNotifikasiView.vue?vue&type=script&lang=js"
import style0 from "./PengaturanNotifikasiView.vue?vue&type=style&index=0&id=378ab79c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ab79c",
  null
  
)

export default component.exports